import React, { useRef, useState } from 'react';
import useSWR from 'swr'




import {faBuildingColumns } from '@fortawesome/free-solid-svg-icons'


import  useUser  from "../hooks/useUser";
import  useLocation  from "../hooks/useLocation";

import SideBarItem from "./SideBarItem";

import { Checkbox } from '@mui/material';
import { useNavigate } from "react-router-dom";
import WriteLog from './Globals/WriteLog';
import Fetcher from './Globals/Fetcher'



function LocationSidebar({routingPage}) {

    const navigate  = useNavigate();    
    const  {user}  = useUser()    
    const allRef  = useRef(true) 
    

    // const fetcher = Fetcher()
    // var { data, error } = useSWR([process.env.REACT_APP_SERVER_BASE_URL +'/crm/tasks?filter_option=1&ext_low_prio=0', 
    // {   method: 'GET',
    //     headers: {
    //                 'Authorization': user?.token,
    //             }
    // }
    // ], fetcher)
    // const tasks = data;    
    // WriteLog("LocationSidebar->tasks",tasks);


    const  {locations}  = useLocation(user?.customer_code, user?.token);

    WriteLog("LocationSidebar->locations", locations)
    
    //const [allLocation, toggleValue] = useToggle(true);
    const [allLocation, setAllLocation] = useState(false)

    WriteLog("LocationSidebar->allLocation root", allLocation)
        
    function ShowAllLocation(e)
    {           
        WriteLog("LocationSidebar->allLocation first", allLocation)        
        if( allLocation == false)   
        {
            navigate(routingPage+"/-1");
            setAllLocation(true);        
        }            
        else
        {
            setAllLocation(false);        
            navigate(routingPage+"/0");
        }
            
        
        WriteLog("LocationSidebar->allLocation second", allLocation)

    }

  return (
    <div className="w-[360px] bg-slate-100 h-screen shadow-lg rounded">        
        <div className="p-5 text-3xl font-semibold bg-gray-100 rounded-lg shadow-md" >
            {user?.customer_name}       
        </div>
        <div className="flex justify-between items-center  bg-gray-300 rounded-lg pl-1">            
            All Locations
            <Checkbox checked={allLocation} color="default" onClick={(e)=>{ShowAllLocation(e)}} ></Checkbox>
            
        </div>
        
        <div className="ml-1 mr-1 mt-2 overflow-y-auto h-4/6">            
            {locations?.locations?.map((p) => (                    
                <SideBarItem key={`${p.AddrSeq}`} routing={routingPage} addrSeq={p.AddrSeq} name={p.Name} description={p.Address} Icon={faBuildingColumns} hero={false} trigger={setAllLocation} />                    
                // <SideBarItem key={`${p.AddrSeq}`} routing={routingPage+"?addr_seq="+p.AddrSeq} name={p.Name} description={p.Address} Icon={faBuildingColumns} hero={false} />                    
            ))} 
        </div>         
    </div>    
  )
}

export default LocationSidebar